import CryptoJS from "crypto-js";

const SECRET_KEY = "TghGNPsxxU/tQwkM/afrcQ==";//AMASI

// Make Base64 URL-safe
const base64UrlEncode = (str) =>
  str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

const base64UrlDecode = (str) => {
  let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4) {
    base64 += "=";
  }
  return base64;
};

export const encryptSlug = (text) => {
  const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
  return base64UrlEncode(encrypted);
};

export const decryptSlug = (encodedCipherText) => {
  try {
    const base64Cipher = base64UrlDecode(encodedCipherText);
    const bytes = CryptoJS.AES.decrypt(base64Cipher, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};
